define(['jquery',
        'core/urls',
        'moment'],
    function($, urls) {

        var LogoRepository = {
            save: function (uuid) {
                return $.ajax({
                    method: 'POST',
                    url: urls['configuration:save-logo'](),
                    data: {file_uuid: uuid}
                });
            },
            updateTitle: function (logoId, title) {
                var endpointUrl = urls['configuration:update-logo'](logoId);

                return $.ajax({
                    method: 'POST',
                    url: endpointUrl,
                    data: {title: title}
                });
            },
            delete: function (logoId) {
                var endpointUrl = urls['configuration:delete-logo'](logoId);

                return $.ajax({
                    method: 'POST',
                    url: endpointUrl
                });
            },
            undoDelete: function (logo) {
                var logoId = logo.id,
                    endpointUrl = urls['configuration:undo-delete-logo'](logoId);

                return $.ajax({
                    method: 'POST',
                    url: endpointUrl
                });
            }
        };

        return {
            LogoRepository: LogoRepository
        };
    }
);